// Icons
import Average from "@/assets/icons/socialMedia/average.svg";
import BBB from "@/assets/icons/socialMedia/betterbusinessbureau.svg";
import Cars from "@/assets/icons/socialMedia/cars.svg";
import CarFax from "@/assets/icons/socialMedia/carFax.svg";
import CarGurus from "@/assets/icons/socialMedia/carGurus.svg";
import DealerRater from "@/assets/icons/socialMedia/dealerraterrounded.svg";
import Edmunds from "@/assets/icons/socialMedia/edmunds.svg";
import Facebook from "@/assets/icons/socialMedia/facebook.svg";
import Google from "@/assets/icons/socialMedia/google.svg";

// Types
import { IRatingConfig } from "../components/OnlineRatings/interfaces";
import { IReviewSiteSummary } from "@DataPages/types/socialMediaReviews/model";

interface ISiteData {
	key: string;
	label: string;
	icon: string;
	totalCount: number;
	totalAvg: number;
	value?: number;
}

const sites: ISiteData[] = [
	{
		key: "google",
		label: "Google",
		icon: Google,
		totalCount: 0,
		totalAvg: 0,
	},
	{
		key: "facebook",
		label: "Facebook",
		icon: Facebook,
		totalCount: 0,
		totalAvg: 0,
	},
	{
		key: "cars",
		label: "Cars.com",
		icon: Cars,
		totalCount: 0,
		totalAvg: 0,
	},
	{
		key: "dealerrater",
		label: "DealerRater",
		icon: DealerRater,
		totalCount: 0,
		totalAvg: 0,
	},
	{
		key: "cargurus",
		label: "Cargurus",
		icon: CarGurus,
		totalCount: 0,
		totalAvg: 0,
	},
	{
		key: "carfax",
		label: "Carfax",
		icon: CarFax,
		totalCount: 0,
		totalAvg: 0,
	},
	{
		key: "bbb",
		label: "BBB",
		icon: BBB,
		totalCount: 0,
		totalAvg: 0,
	},
	{
		key: "edmunds",
		label: "Edmunds",
		icon: Edmunds,
		totalCount: 0,
		totalAvg: 0,
	},
];

const getAverage = (ratings: IReviewSiteSummary[] = []): ISiteData => {
	const average = {
		key: "average",
		label: "Average",
		icon: Average,
		value: 0,
		totalAvg: 0,
		totalCount: 0,
	};

	if (!ratings.length) {
		return average;
	}
	ratings.forEach((rating) => {
		if (rating.reviewCount) {
			average.value += rating.averageRating;
		}
	});

	average["value"] = average.value / ratings.length;
	return average;
};

export const filterStoreRatings = (ratings: IReviewSiteSummary[] = []): IRatingConfig[] => {
	if (!ratings?.length) {
		return [];
	}

	const average = getAverage(ratings);

	const foundedSites = sites.filter((site) => ratings.find((rating) => rating.siteName === site.key));

	const sitesData = foundedSites.map((site) => {
		const siteReview = ratings.find((rating) => rating.siteName === site.key);
		if (siteReview) {
			site.value = siteReview.averageRating;
		}
		return site;
	});

	sitesData.push(average);

	return sitesData
		.map((item) => ({
			label: item.label,
			icon: item.icon || null,
			value: Math.round(Number(item.value) * 100) / 100,
		}))
		.filter((item) => Boolean(item.value));
};
